import React, { useEffect } from "react";

import { View, ScrollView } from "react-native";
import { Error, Loading, GridView, CompanyCard, UpdateAlert } from "component";

import HomeHeader from "./HomeHeader";
import UserCodeAlert from "./UserCodeAlert";

import { css } from "style";
import { VERSION, colors } from "asset/constant";

import { useHome, useVersion } from "client/api";
import ReloadCompaniesList from "./ReloadCompaniesList";
import { useFlag, useSN } from "hook";
import { useRecoilValue } from "recoil";
import { authAtom } from "store";
import size from "asset/constant/sizes";
import { _openDrawer } from "router/helper";

export default function Home() {
  const sn = useSN();

  const auth = useRecoilValue(authAtom);
  const { data: updateInfo, isLoading: updateLoading } = useVersion();
  const { data, error, refetch, isError, isLoading, isRefetching } = useHome();

  const { flg: update, on: showUpdate, off: hideUpdate } = useFlag();

  useEffect(() => {
    if (Number(updateInfo?.data?.version) > Number(VERSION.APP)) {
      if (updateInfo?.data?.is_force === 1) {
        showUpdate();
        return;
      }

      if (
        auth?.upgrade?.version === updateInfo?.data?.version &&
        !auth?.upgrade?.dntShow
      ) {
        showUpdate();
        return;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateInfo]);

  const _renderCompanyCard = (item: CompanyCardT) => (
    <CompanyCard company={item} />
  );

  const _renderContent = () => {
    if (isLoading || updateLoading) {
      return <Loading />;
    }

    if (isError) {
      return <Error error={error} reset={refetch} loading={isRefetching} />;
    }

    if (data?.data?.companies?.length > 0) {
      const companies =
        data?.data?.companies?.length % 2 === 0
          ? data?.data?.companies
          : [...data?.data?.companies, undefined];

      return (
        <ScrollView
          showsVerticalScrollIndicator={false}
          contentContainerStyle={{
            ...css.rRowWrap,
            ...css.justifySEvenly,
            backgroundColor: colors.bg.screen,
          }}
        >
          <>
            <GridView
              spacing={size.space}
              numberOfCol={sn(2, 3, 4, 5)}
              data={companies}
              renderItem={_renderCompanyCard}
            />
          </>
        </ScrollView>
      );
    }

    return <UserCodeAlert />;
  };

  return (
    <>
      <HomeHeader />
      <View style={{ ...css.container }}>
        <ReloadCompaniesList onReload={refetch} loading={isRefetching} />

        {_renderContent()}
      </View>

      <UpdateAlert
        visible={update}
        hide={hideUpdate}
        updateInfo={updateInfo?.data}
      />
    </>
  );
}
